import React from "react";
import Navbar from "./Essentials/Navbar";
import Footer from "./Essentials/Footer";

function Designations() {
  return (
    <div>
      <Navbar />
      <center>
        <iframe
          src="https://drive.google.com/file/d/1_zva_soB7sIAZPGhCWS-PQJLRi8W8Cuv/preview"
          width="50%"
          height="480"
          allow="autoplay"
        />
      </center>
      <Footer />
    </div>
  );
}

export default Designations;
